module.exports = __webpack_public_path__ + "img/icon_wait_proxy.c3ac5b4a.svg";